import {Edit} from "react-admin";
import {CompanyDetails} from "./CompanyDetails";
export const CompanyEdit = () => {
    return (
        <Edit mutationMode="pessimistic">
            <CompanyDetails />
        </Edit>
    )
}